var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlinePayment5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-164 42.3 512 512",
    style: {
      enableBackground: "new -164 42.3 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7ED5C5;}\n\t.st1{fill:#843B90;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.6,298.3H-36v21.3h256v-21.3h-60.3c18.5-13,33.2-31.4,41.7-53.3h57.1l35.2,39.1c2,2.2,4.9,3.5,7.9,3.5 h35.8v-21.3h-31.1l-35.2-39.1c-2-2.2-4.9-3.5-7.9-3.5H188c-5.9,0-10.7-4.8-10.7-10.7c0-17.7,14.3-32,32-32H220 c5.9,0,10.7,4.8,10.7,10.7c0,5.9,4.8,10.7,10.7,10.7h64v-21.3h-55.2c-4.5-12.8-16.6-21.3-30.2-21.3h-10.7c-2.6,0-5.2,0.2-7.7,0.6 c-4.6-11.8-11-22.8-19-32.6l21.9-11.8l41.3,30.4l12.7-17.2l-46.7-34.4c-3.3-2.4-7.8-2.8-11.4-0.8l-86.1,46.6 c-2.2,1.2-4.6,1.8-7.1,1.8c-8.2,0-14.9-6.7-14.9-14.9c0-5.1,2.5-9.8,6.8-12.6l106.3-50.5l129.7,31.1l5-20.7l-133.3-32 c-2.4-0.6-4.9-0.3-7.1,0.7l-90.3,42.8c-5.6-0.8-11.2-1.2-16.9-1.2C27.4,84.9-25.1,137.3-25.2,202.1 C-25.3,241.9-5.5,277,24.6,298.3z M-2,183.2c8.2-40.2,40.3-69.3,78.4-75.6c-3.8,5.8-5.9,12.7-5.9,19.9c0,1.9,0.2,3.8,0.5,5.7 c-12.9,7.3-21.7,21.2-21.7,37.1c0,23.6,19.1,42.7,42.7,42.7c11.8,0,21.3,9.6,21.3,21.3s-9.6,21.3-21.3,21.3s-21.3-9.6-21.3-21.3 H49.3c0,19.9,13.6,36.6,32,41.3v12h21.3v-12c18.4-4.7,32-21.4,32-41.3c0-23.6-19.1-42.7-42.7-42.7c-11.8,0-21.3-9.6-21.3-21.3 c0-7.6,3.9-14.2,9.9-18c6.6,7,16,11.3,26.4,11.3c2.2,0,4.3-0.2,6.4-0.6v17.9h21.3v-27.4l28.7-15.5c7.8,8.6,13.9,18.6,18.1,29.5 c-15.3,9.4-25.5,26.2-25.5,45.5c0,14.4,9.6,26.6,22.7,30.6c-15.7,33.1-49.3,54.8-86.7,54.7c-6.4,0-12.8-0.6-19-1.9 C21,285.8-12.5,235.1-2,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.7,308.9v128c0,5.9-4.8,10.7-10.7,10.7h-448c-5.9,0-10.7-4.8-10.7-10.7V138.3c0-5.9,4.8-10.7,10.7-10.7 h106.7v-21.3H-132c-17.7,0-32,14.3-32,32v298.7c0,17.7,14.3,32,32,32H10.7l-32,64h-25.4v21.3h277.3v-21.3h-25.4l-32-64H316 c17.7,0,32-14.3,32-32v-128H326.7z M181.4,532.9H2.6l32-64h114.8L181.4,532.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -78.7,
    y: 298.3,
    className: "st0",
    width: 21.3,
    height: 21.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-121.3,372.9v42.7c0,5.9,4.8,10.7,10.7,10.7H-68v-21.3h-32v-32L-121.3,372.9L-121.3,372.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -46.7,
    y: 404.9,
    className: "st1",
    width: 21.3,
    height: 21.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284,404.9h-32v21.3h42.7c5.9,0,10.7-4.8,10.7-10.7v-42.7H284V404.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.3,
    y: 404.9,
    className: "st1",
    width: 21.3,
    height: 21.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-46.7,148.9h-42.7c-17.7,0-32,14.3-32,32v170.7h21.3V180.9c0-5.9,4.8-10.7,10.7-10.7h42.7L-46.7,148.9 L-46.7,148.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: 404.9,
    className: "st1",
    width: 192,
    height: 21.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinePayment5);
export default __webpack_public_path__ + "static/media/online-payment-5.0e6acc66ead1946e4798a80775ac5baa.svg";
export { ForwardRef as ReactComponent };